/* =========================================================
   Ters yonde scroll rotasyonu

   Temanin shapes-animations.js dosyasi tum
   .sticker-rotate-when-scrolling ogelerine ayni aciyi uygular
   (pageYOffset / 3), yani hepsi ayni yone doner.

   Bu script, .sticker-rotate-when-scrolling-reverse sinifina
   sahip stickerlari TERS yonde dondurur; boylece bir sticker
   saat yonunde donerken digeri saatin tersine doner.

   Tema gibi prefers-reduced-motion ayarina saygi gosterir.
   ========================================================= */
(function () {
  if (!window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
    return;
  }

  var ticking = false;

  function uygula() {
    var items = document.querySelectorAll('.sticker-rotate-when-scrolling-reverse');
    var aci = -(window.pageYOffset / 3);
    for (var i = 0; i < items.length; i++) {
      items[i].style.transform = 'rotate(' + aci + 'deg)';
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(uygula);
      ticking = true;
    }
  }

  function baslat() {
    uygula();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else {
    baslat();
  }

  document.addEventListener('shopify:section:load', uygula);
})();
